module.exports = {
	"notification.message": "Wix.com では、サービスをより快適にご利用いただけるようCookieを使用しています。",
	"notification.got.it": "閉じる",
	"notification.more.info": "続きを読む",
	"notification.got.it.arrow": "arrow icon"
};


//////////////////
// WEBPACK FOOTER
// ./assets/locale/messages_ja.json
// module id = 53
// module chunks = 0